import * as types from './action_types';
import * as WordActions from '../word/actions';
import * as TackNotificationsActions from '../tack_notifications/actions';
import TackIntervalSelector from '../../services/tack_interval_selector';
import DateMaster from '../utils/date_master';

export const reset = () => {
  return { type: types.TACK_INTERVAL_SELECTION_RESET };
}

export const resetSelectionOptions = () => {
  return { type: types.TACK_INTERVAL_SELECTION_OPTIONS_RESET }
}

export const fetchSelectionOptions = (tackSlug, tackInterval) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_INTERVAL_SELECTION_OPTIONS_LOADING });
      const tackIntervalSelectionOptionsData = await TackIntervalSelector.fetchSelectionOptions(tackSlug, tackInterval);
      const tackIntervalSelectionOptions = [];
      for (let tackIntervalSelectionOption of tackIntervalSelectionOptionsData) {
        tackIntervalSelectionOptions.push({
          slug: tackIntervalSelectionOption.slug,
          definitions: tackIntervalSelectionOption.definition_texts
        });
      }
      dispatch({ type: types.TACK_INTERVAL_SELECTION_OPTIONS_LOADED, tackIntervalSelectionOptions: tackIntervalSelectionOptions });
    } catch(error) {
      dispatch({ type: types.TACK_INTERVAL_SELECTION_ERROR, error });
    }
  }
}

export const select = (tackSlug, tackIntervalSelectionMask) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_INTERVAL_SELECTION_LOADING });
      const tackIntervalSelectionData = await TackIntervalSelector.select(tackSlug, tackIntervalSelectionMask);
      const tackIntervalSelection = {
        tackInterval: tackIntervalSelectionData.tack_interval,
        isCorrect: tackIntervalSelectionData.is_correct,
        isTackDone: tackIntervalSelectionData.tack_is_done,
        tackSlug: tackIntervalSelectionData.tack_slug,
        language: tackIntervalSelectionData.language,
        correctWordText: tackIntervalSelectionData.correct_word_text,
        nextSendDate: DateMaster.parseUTC(tackIntervalSelectionData.next_send_date),
        createdAt: DateMaster.parseUTC(tackIntervalSelectionData.created_at)
      }
      if (!tackIntervalSelection.isCorrect) {
        dispatch(WordActions.fetch(tackIntervalSelection.correctWordText));
      }
      dispatch(TackNotificationsActions.unreadCount());
      dispatch({ type: types.TACK_INTERVAL_SELECTION_SELECTED, tackIntervalSelection: tackIntervalSelection });
    } catch(error) {
      dispatch({ type: types.TACK_INTERVAL_SELECTION_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack_interval_selections/actions.js